export default {
  JP: {
    regex: {
      // Contains the following unicode sets:
      //    u3000-u30ff Ideographic symbols, brackets and dots
      //    u30a0-u30ff Katakana-Hiragana
      //    u3040-u309f Hiragana
      //    u4e00-u9faf Ideographic symbols
      //    uff00-uffee Full and half width characters
      allowedCharacters: "^([\u30a0-\u30ff]|[\u3000-\u303f]|[a-zA-Z0-9\s\.!\\/:@#&*-’, ]|[\u4e00-\u9faf]|[\uff00-\uffee]|[\u3040-\u309f]|\/\s)*$"
    }
  }
}
